import { createSourcedAction } from '@ces/sourced-action';
import { props } from '@ngrx/store';
import { BTaxState } from 'egov-api';

export const loadBTaxState = createSourcedAction('Load BTax State');
export const btaxStateLoadFailed = createSourcedAction('BTax State Load failed');
export const btaxStateLoaded = createSourcedAction('BTax State Loaded', props<{ newState: BTaxState }>());
